<template>
  <div class="text-left">
    {{ votingsMandateRepresentantName }}
  </div>
</template>

<script>
export default {
  props: {
    mainMandate: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      mainMandateData: {},
    };
  },
  computed: {
    votingsMandateRepresentantName() {
      var representedBy = this.getRepresentedBy(this.mainMandateData);
      if (representedBy == "himself") return "";
      else if (representedBy == "owner")
        return this.getPersonNameAndGender({
          personId: this.mainMandateData.representant_owner_id,
        });
      else if (representedBy == "contact")
        return this.getPersonNameAndGender({
          personId: this.mainMandateData.representant_contact_id,
          personType: "contact",
        });
      else return "";
    },
  },
  watch: {
    mainMandate(newVal, oldVal) {
      if (!this.$_.isEqual(newVal, oldVal)) {
        this.mainMandateData = newVal;
      }
    },
  },
  created() {
    this.mainMandateData = this.mainMandate;
  },
  methods: {
    getRepresentedBy(item) {
      if (item.representant_owner_id) {
        if (item.representant_owner_id == item.building_owner_id) return "himself";
        else return "owner";
      } else if (item.representant_contact_id) {
        return "contact";
      }
    },
  },
};
</script>
